import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CustomerAccountHeaderComponent } from './components/customerAccounts/customer-account-header/customer-account-header.component';
import { CustomerAccountComponent } from './components/customerAccounts/customer-account/customer-account.component';
import { CustomerSearchComponent } from './components/customerAccounts/customer-search/customer-search.component';
//import { InteractionHistoryComponent } from './components/customerAccounts/interaction-history/interaction-history.component';
import { OpenAccountComponent } from './components/customerAccounts/open-account/open-account.component';
import { DashboardComponent } from './components/dashboard/deshboard/dashboard.component';
import { LoginComponent } from './components/login/login.component';
import { LogoutPageComponent } from './components/logout-page/logout-page.component';
import { MainComponent } from './components/main/main.component';
import { AuthGuard } from './guards/auth.guard';
import { StyleguideComponent } from './components/styleguide/styleguide.component';
import { SsofailureComponent } from './components/ssofailure/ssofailure.component';
import { CustomerSearchUnidentifiedCallComponent } from './components/customerAccounts/customer-search-unidentified-call/customer-search-unidentified-call.component';
import { SimulationManagerComponent } from './components/simulation-manager/simulation-manager.component';
import { AdministrationComponent } from './components/administration/administration.component';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'styleguide', component: StyleguideComponent },
  {
    path: 'log-out',
    component: LogoutPageComponent
  },
  { path: 'home/sso/:sessionId/:emailId', component: LoginComponent },
  {
    path: 'ssoerror',
    component: SsofailureComponent
  },
  {
    path: 'home/sso/ValidateSession',
    component: LoginComponent
  },
  {
    path: '',
    component: MainComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', component: DashboardComponent },
      { path: 'customer-search', component: CustomerSearchComponent },
      { path: 'open-account', component: OpenAccountComponent },
      { path: 'customer-account/:id', component: CustomerAccountComponent },
      // { path: 'interaction-history', component: InteractionHistoryComponent },
      { path: 'customer-search-unidentified-call/:id', component: CustomerSearchUnidentifiedCallComponent },
      { path: 'simulation-manager', component: SimulationManagerComponent  },
      { path: 'administration', component: AdministrationComponent  }
    ],
  },
  { path: "**", redirectTo: "", pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
